import { Record } from 'immutable';
import { selectMapperForPage } from '../../graphql/selectors';
import { CONTENT_UPDATE } from './actions';

const PLUS_CONTENT_KEY = 'plus';

export const InitialState = new Record({
  plus: {}
});

export default (state = new InitialState(), action) => {
  const { type, data } = action;

  switch (type) {
    case CONTENT_UPDATE: {
      const mapper = selectMapperForPage({ contentKey: PLUS_CONTENT_KEY });
      return state.set(PLUS_CONTENT_KEY, mapper(data));
    }

    default:
      return state;
  }
};
